import { useAppContext } from "../../../context/AppContext";
import { formatCurrency } from "../../../utils/formatCurrency";

export const TableLandsAvailable = ({ table, nomenclature }) => {
  return (
    <>
      {table.map((block) => (
        <div key={block.id} className="mt-3">
          <h4>
            {nomenclature[0].value}: {block.name}
          </h4>
          <div className="row ps-4">
            {block.lands.map((land) => (
              <div
                key={land.id}
                className="col-xl-1 col-md-2 border text-center py-2 px-3 rounded mx-1"
                style={{ backgroundColor: "#00b9a6" }}
              >
                <h5>{land.name}</h5>
                <h6>M²: {land.m2}</h6>
                <h6>{land.value && formatCurrency(land.value)}</h6>
              </div>
            ))}
          </div>
          <div className="text-end pe-3 mt-3 text-secondary">
            <h5>
              Quantidade {nomenclature[1].value} Disponíveis:{" "}
              {block.lands_count}
            </h5>
            {block.lands_sum_value && (
              <h5>
                Valor Total {nomenclature[1].value} Disponíveis:{" "}
                {block.lands_sum_value && formatCurrency(block.lands_sum_value)}
              </h5>
            )}
          </div>
          <hr />
        </div>
      ))}
    </>
  );
};
